import React from 'react';

import Routes from './routes';
import PsContextProvider from './views/context/PsContextProvider';

export default () => (

  <PsContextProvider>
    <Routes />
  </PsContextProvider>

);
